import { createFileRoute } from "@tanstack/react-router";
import PublicDashboardView from "@/components/dashboard/public/public-dashboard-view";

// Dashboard compartido por enlace publico (docs/public-dashboard-plan.md).
export const Route = createFileRoute("/_public/shared/dashboards/$token")({
  component: PublicDashboardPage,
});

function PublicDashboardPage() {
  const { token } = Route.useParams();
  return <PublicDashboardView token={token} />;
}
